require('./ruleBuilder.tpl.html');
require('./header/ruleBuilderHeaderComponent.js');

/*@ngInject*/
const RuleBuilderController = function ($rootScope, $scope, $stateParams, ruleModel, ruleUtil,
                                        configurationConstant, currentUserModel,
                                        authorizationConstants, umStudioConstant,
                                        ruleEntryStatus, loadingBarHandler, configurationMediator,
                                        $uibModal, localization) {

    $scope.viewModel = {
        rule: null,
        topLevelRuleCondition: {},
        ruleActions: {},
        ruleSetName : '',
        translations:null
    };

    function init() {
        ruleModel.buildRule($stateParams.ruleId).then(function () {
            var rule = ruleModel.getRule($stateParams.ruleId);
            $scope.viewModel.rule = rule;
            $scope.viewModel.topLevelRuleCondition = rule.condition;
            $scope.viewModel.ruleActions = rule.actions;
            $scope.viewModel.ruleSetName = ruleUtil.getRuleSetName(rule);
            $scope.viewModel.canUserManageFormRules = canManageFormRules();
        });

        localization.getTranslationByKey('ruleBuilderHeader').then(function (translations) {
            $scope.viewModel.translations = translations;
        }.bind(this));

    }

    function canManageFormRules() {
        var rule = ruleModel.getRule(parseInt($stateParams.ruleId));
        return currentUserModel.hasAuthorization(authorizationConstants.MANAGE_RULES) && rule.status !== ruleEntryStatus.STATUS_INACTIVE;
    }

    $scope.$on('$destroy', function () {
        ruleModel.reset($stateParams.ruleId);
    });

    $scope.$on(configurationConstant.event.RULE_MODEL_UPDATED, function (event, ruleId) {
        var rule = null;

        if (parseInt($stateParams.ruleId) === ruleId) {
            rule = ruleModel.getRule(ruleId);
            $scope.viewModel.topLevelRuleCondition = rule.condition;
            $scope.viewModel.ruleActions = rule.actions;
            $scope.viewModel.ruleSetName = ruleUtil.getRuleSetName(rule);
        }
    });

    $scope.$on(umStudioConstant.event.RULE_STATUS_UPDATED, function () {
        $scope.viewModel.canUserManageFormRules = canManageFormRules();
    });

    $scope.$on(umStudioConstant.event.RULE_UPDATED, function () {
        ruleModel.setUnsavedChanges($stateParams.ruleId, /*hasUnsavedChanges*/true);
    });

    $scope.handleChange = function() {
      $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
    }

    $scope.generateRuleObject = function () {
        $scope.viewModel.ruleObjectString = JSON.stringify($scope.viewModel.topLevelRuleCondition, null, 4);
    };

    $scope.reviewRule = function () {
        var rule = ruleModel.getRule(parseInt($stateParams.ruleId));
        loadingBarHandler.showNotificationLoadingBar(_.get($scope.viewModel.translations, 'reviewRuleNotificationMessage'));
        return configurationMediator.validateRule(rule).then(function (result){
            showValidateRuleModal(result);
        }).finally(function () {
            loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
        });
    }

    function showValidateRuleModal(validateRuleResult) {
        var instance = $uibModal.open({
            templateUrl: '/configuration/formEditor/content/rule/reviewRule/validateRuleModal.tpl.html',
            controller: 'validateRuleModalController',
            windowClass: 'validateRuleModal',
            resolve: {
                options: function () {
                    return {
                        ruleText: validateRuleResult.ruleText,
                        error: validateRuleResult.errors
                    };
                }
            }
        });
        return instance.result;
    }

    init();
};

angular.module('ums.configuration')
    .controller('ruleBuilderController', RuleBuilderController);
